import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Link from 'shared/components/Link';
import { imageBgStyle, numberWithSpaces } from 'shared/helpers/common';
import economUrl from 'shared/assets/images/car-body/grey-outline/png/124/coupe.png';
import standartUrl from 'shared/assets/images/car-body/grey-outline/png/124/hardtop-4.png';
import comfortUrl from 'shared/assets/images/car-body/grey-outline/png/124/cabrio-4.png';
import businessUrl from 'shared/assets/images/car-body/grey-outline/png/124/liftback-5.png';
import premiumUrl from 'shared/assets/images/car-body/grey-outline/png/124/crossover-full.png';
import CARS_CATEGORY from 'shared/data/json/newCarsCategory.json';
import s from './NewCars.css';

const DEALER_PIECE_URL = 'from_dealer=1&official_dealer=1';

class NewCars extends React.Component {
  static propTypes = {
    newCars: PropTypes.shape(),
  };

  static defaultProps = {
    newCars: {},
  };

  transformLink = link => `/${link}&${DEALER_PIECE_URL}`;

  render() {
    const { newCars } = this.props;
    const carImgs = {
      econom: economUrl,
      standard: standartUrl,
      comfort: comfortUrl,
      business: businessUrl,
      premium: premiumUrl,
    };

    return (
      <div className={s.root}>
        <div className={s.title}>
          <Link to={`/avto/novye/?${DEALER_PIECE_URL}`} className={s.link}>
            <FormattedMessage id="Новые авто от официальных дилеров" />
          </Link>
        </div>
        <div className={s.list}>
          {CARS_CATEGORY.map(item => (
            <div className={s.type} key={item.link}>
              <Link to={this.transformLink(item.link)} className={s.itemLink} rel="nofollow">
                <div className={s.thumb} style={imageBgStyle(carImgs[item.image], 'contain')} />
                <div className={s.itemTitle}>
                  <FormattedMessage id={item.title} />
                </div>
                {newCars[item.slug] ? (
                  <div className={s.count}>
                    {numberWithSpaces(newCars[item.slug])} <FormattedMessage id="авто" />
                  </div>
                ) : (
                  <div />
                )}
                {item.price && (
                  <div className={s.price}>
                    {numberWithSpaces(item.price)} <FormattedMessage id="грн" />
                  </div>
                )}
              </Link>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(NewCars);



// WEBPACK FOOTER //
// ./src/desktop/routes/home/components/NewCars/NewCars.js